export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13256.8e875c80.jpg";